import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { Observable } from 'rxjs';
import { TipoProductoModel } from '../Modelo/TipoProducto.model';

@Injectable({
    providedIn: 'root'
})
export class TiposDeProductosService {

    constructor(
        private Utilidades: UtilidadesService
    ) { }

    public Lista(): Observable<TipoProductoModel[]> {
        return this.Utilidades.Get("TiposDeProductos");
    }
}